import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-24 bg-sage/10 relative" data-id="element-110">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-111">
        <FadeIn data-id="element-112">
          <h2 className="font-heading text-3xl md:text-4xl text-charcoal mb-8" data-id="element-113">
            ¿Cómo funciona la herencia emocional?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 relative" data-id="element-114">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[1px] bg-gold/30 z-0" data-id="element-115" />

          <FadeIn delay={0.1} className="relative z-10" data-id="element-116">
            <div className="bg-beige w-24 h-24 rounded-full mx-auto flex items-center justify-center shadow-md border border-gold/20 mb-6" data-id="element-117">
              <span className="font-heading text-3xl text-gold-dark" data-id="element-118">1</span>
            </div>
            <h3 className="font-heading text-xl text-charcoal mb-3" data-id="element-119">
              El Impacto
            </h3>
            <p className="font-body text-sm text-charcoal/70" data-id="element-120">
              Un ancestro vive un trauma profundo (escasez, abandono, pérdida)
              que no puede procesar ni sanar en su momento.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="relative z-10" data-id="element-121">
            <div className="bg-beige w-24 h-24 rounded-full mx-auto flex items-center justify-center shadow-md border border-gold/20 mb-6" data-id="element-122">
              <span className="font-heading text-3xl text-gold-dark" data-id="element-123">2</span>
            </div>
            <h3 className="font-heading text-xl text-charcoal mb-3" data-id="element-124">
              La Transmisión
            </h3>
            <p className="font-body text-sm text-charcoal/70" data-id="element-125">
              La epigenética demuestra que esa respuesta de estrés altera la
              expresión genética, transmitiéndose a las siguientes generaciones.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} className="relative z-10" data-id="element-126">
            <div className="bg-beige w-24 h-24 rounded-full mx-auto flex items-center justify-center shadow-md border border-gold/20 mb-6" data-id="element-127">
              <span className="font-heading text-3xl text-gold-dark" data-id="element-128">3</span>
            </div>
            <h3 className="font-heading text-xl text-charcoal mb-3" data-id="element-129">
              La Repetición
            </h3>
            <p className="font-body text-sm text-charcoal/70" data-id="element-130">
              Tú heredas el patrón y lo repites inconscientemente como una forma
              de lealtad familiar, hasta que decides cortarlo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}